import { IComponentOptions, IController } from 'angular';
import { GmcAccordionController } from '../../gmc-accordion.component';
import './gmc-accordion-tab.component.scss';

export class GmcAccordionTabController implements IController {
  public tabName: string;
  public isActive = false;
  private accordionCtrl: GmcAccordionController;

  public $onInit() {
    this.accordionCtrl.addTab(this);
  }

  public $onDestroy() {
    this.accordionCtrl.removeTab(this);
  }

  public toggleTab() {
    this.accordionCtrl.toggleTab(this);
  }
}

export const GmcAccordionTabComponent: IComponentOptions = {
  controller: GmcAccordionTabController,
  template: require('./gmc-accordion-tab.component.html'),
  transclude: {
    tabHeader: '?gmcAccordionTabHeader'
  },
  require: {
    accordionCtrl: '^gmcAccordion'
  },
  bindings: {
    tabName: '@',
    isActive: '=?'
  }
};




// WEBPACK FOOTER //
// ./app/shared/components/gmc-accordion/components/gmc-accordion-tab/gmc-accordion-tab.component.ts